const m = window.require("discourse/models/permission-type");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;